export default "__VITE_ASSET__iImIPYpI__"